import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  <span style="color:#a6d189;">**{title}**</span> tooteinfo

  <span style="color:#85c1dc;">**FI:**</span>
  <span style="color:#a6d189;">**{title}**</span> tuotetiedot

  <span style="color:#85c1dc;">**RU:**</span>
  <span style="color:#a6d189;">**{title}**</span> информация о товаре
*/
/* @__NO_SIDE_EFFECTS__ */
const m1151 = msg(
  mf`${'title'} tooteinfo`,
  mf`${'title'} tuotetiedot`,
  mf`${'title'} информация о товаре`,
)

export { m1151 as 'w.module.product_description.product_title' }